import {
	IGetFirmwareInfo,
	ICreateUpdateFirmware,
	IGetPaginatedFirmware,
	IFirmware,
	IGetPaginatedFirmwareForAssign,
	IFirmwareForAssign,
	IGetRestaurantsByIDsCustomersForFirmware,
	IGetFirmwareByIDsRestaurantsForFirmware,
	IAssignFirmware,
	IGetCustomersForAssignFirmware,
} from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetFirmwareInfo = (firmwareID: string): Promise<IGetFirmwareInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Firmwares/${firmwareID}` });
};

const serviceCreateFirmware = (data: ICreateUpdateFirmware): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Firmwares`, data });
};

const serviceUpdateFirmware = (data: ICreateUpdateFirmware): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Firmwares/${data.id}`, data });
};

const serviceGetPaginatedFirmware = (args: IGetPaginatedFirmware): Promise<AxiosResponse<IFirmware>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Firmwares/filtered`, data: args });
};

const serviceDeleteFirmware = (firmwareID: string): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine', url: `/api/Firmwares/${firmwareID}` });
};

const serviceGetPaginatedFirmwareForAssign = (
	args: IGetPaginatedFirmwareForAssign,
): Promise<AxiosResponse<IFirmwareForAssign>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/RestaurantFirmwares/filtered`, data: args });
};

const serviceGetCustomersForAssignFirmware = (): Promise<IGetCustomersForAssignFirmware> => {
	return request({ typeOfRequest: 'getWithToken', url: '/api/CustomerFirmwares' });
};

const serviceGetRestaurantsByIDsCustomersForFirmware = (
	customerIDs: string[],
): Promise<IGetRestaurantsByIDsCustomersForFirmware> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/RestaurantFirmwares/restaurants`, data: customerIDs });
};

const serviceGetFirmwaresByIDsRestaurantsForFirmware = (
	restaurantIDs: string[],
): Promise<IGetFirmwareByIDsRestaurantsForFirmware> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/RestaurantFirmwares/firmwares`, data: restaurantIDs });
};

const serviceAssignFirmware = (data: IAssignFirmware[]): Promise<AxiosResponse<void>> => {
	const dataForAssign = {
		assignments: data,
	};
	return request({ typeOfRequest: 'postWithToken', url: '/api/RestaurantFirmwares', data: dataForAssign });
};

export {
	serviceGetFirmwareInfo,
	serviceCreateFirmware,
	serviceUpdateFirmware,
	serviceGetPaginatedFirmware,
	serviceDeleteFirmware,
	serviceGetPaginatedFirmwareForAssign,
	serviceGetCustomersForAssignFirmware,
	serviceGetRestaurantsByIDsCustomersForFirmware,
	serviceGetFirmwaresByIDsRestaurantsForFirmware,
	serviceAssignFirmware,
};
